<template>
    <v-card>
        <v-card-title class="justify-center" style="font-size: 1.8em">
            Detalhes do Cliente
        </v-card-title>
        <v-card-text style="font-size: 1.2em;">
            <v-layout justify-spacer-between wrap>
                <v-flex xs5>
                    <b>Identificador:</b> {{ cliente.pessoa.id_pessoa || 'Não informado' }}
                </v-flex>
                <v-flex xs6>
                    <b>Nome:</b> {{ cliente.pessoa.nome_completo || 'Não informado' }}
                </v-flex>
                <v-flex xs5 class="mt-3">
                    <b>Data cadastro:</b> {{ cliente.pessoa.data_cadastro | formatDate('DD/MM/YYYY') }}
                </v-flex>
                <v-flex xs6 class="mt-3">
                    <b>Local:</b> {{ cliente.pessoa.local || 'Não informado' }}
                </v-flex>
                <v-flex xs12 class="mt-4">
                <v-tabs
                    v-model="active"
                    fixed-tabs
                >
                    <v-tab ripple>
                        <v-icon class="mr-1">local_gas_station</v-icon>Posto
                    </v-tab>
                    <v-tab ripple v-if="posto.rede && inscricao_rede">
                        <v-icon class="mr-1">ac_unit</v-icon>Rede
                    </v-tab>
                    <v-tab-item>
                        <v-card flat>
                        <v-card-text>
                            <v-layout justify-space-between wrap v-if="inscricao_posto">
                                <v-flex xs5>
                                    <b>Recebe e-mail:</b> {{ inscricao_posto.inscrito_email ? 'SIM' : 'NÃO' }}
                                </v-flex>
                                <v-flex xs5>
                                    <b>Recebe Notificações:</b> {{ inscricao_posto.inscrito_push ? 'SIM' : 'NÃO' }}
                                </v-flex>
                                <v-flex xs5>
                                    <b>Número de compras:</b> {{ inscricao_posto.numero_compras }}
                                </v-flex>
                                <v-flex xs5>
                                    <b>Assinante:</b> {{ inscricao_posto.tem_assinatura ? 'SIM' : 'NÃO' }}
                                </v-flex>
                                <v-flex xs5>
                                    <b>Cliente Plus:</b> {{ inscricao_posto.cliente_plus ? 'SIM' : 'NÃO' }}
                                </v-flex>
                                <v-flex xs5>
                                    <b>Pontuação:</b> {{ inscricao_posto.pontuacao }} {{ inscricao_posto.pontuacao === 1 ? 'pt' : 'pts' }}
                                </v-flex>
                                <v-flex xs12 class="mt-3">
                                    <v-btn round small block color="primary" @click="() => tooglePlusCustomer(false)">
                                        <v-icon class="mr-1">{{ inscricao_posto.cliente_plus ? 'star' : 'star_outline' }}</v-icon> {{ inscricao_posto.cliente_plus ? 'Retira Plus' : 'Tornar Plus' }}
                                    </v-btn>
                                </v-flex>
                                <template v-if="inscricao_posto.assinatura">
                                    <v-flex xs12 class="mt-3">
                                        <h3
                                            class="text-xs-center"
                                            style="font-weight:400;"
                                        >
                                            Dados da Assinatura
                                        </h3>
                                    </v-flex>
                                    <v-flex xs5 class="mt-3">
                                        <b>Plano:</b> {{ inscricao_posto.assinatura.plano ? inscricao_posto.assinatura.plano.descricao : 'Não informado' }}
                                    </v-flex>
                                    <v-flex xs5 class="mt-3">
                                        <b>Valor:</b> {{ inscricao_posto.assinatura.plano.valor | currency({fractionCount: 2}) }}
                                    </v-flex>
                                    <v-flex xs5 class="mt-3">
                                        <b>Data de assinatura:</b> {{ inscricao_posto.assinatura.data | formatDate('DD/MM/YYYY') }}
                                    </v-flex>
                                    <v-flex xs5 class="mt-3">
                                        <b>Data de cobrança:</b> {{ inscricao_posto.assinatura.data_cobranca | formatDate('DD/MM/YYYY') }}
                                    </v-flex>
                                    <v-flex xs5 class="mt-3">
                                        <b>Data de encerramento:</b> {{ inscricao_posto.assinatura.data_encerramento | formatDate('DD/MM/YYYY') }}
                                    </v-flex>
                                </template>
                            </v-layout>
                        </v-card-text>
                        </v-card>
                        <v-flex xs12 class="mt-4">
                            <h4 class="text-xs-center">Combustíveis Comprados</h4>
                            <v-list v-if="inscricao_posto">
                                <template v-for="(combustivel, index) in inscricao_posto.combustiveis">
                                    <v-divider :key="`${index}d`"></v-divider>
                                    <v-list-tile :key="`${index}l`">
                                        <v-list-tile-avatar>
                                            <svg-filler
                                            :path="combustivel.icone ? require(`@/assets/combs/${combustivel.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                                            width="50px"
                                            height="50px"
                                            :fill="combustivel.color"
                                            />
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ combustivel.nome }}</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-flex>
                    </v-tab-item>
                    <v-tab-item v-if="posto.rede && inscricao_rede">
                        <v-card flat>
                        <v-card-text>
                            <v-layout justify-space-between wrap v-if="inscricao_rede">
                                <v-flex xs5>
                                    <b>Recebe e-mail:</b> {{ inscricao_rede.inscrito_email ? 'SIM' : 'NÃO' }}
                                </v-flex>
                                <v-flex xs5>
                                    <b>Recebe Notificações:</b> {{ inscricao_rede.inscrito_push ? 'SIM' : 'NÃO' }}
                                </v-flex>
                                <v-flex xs5>
                                    <b>Número de compras:</b> {{ inscricao_rede.numero_compras }}
                                </v-flex>
                                <v-flex xs5>
                                    <b>Assinante:</b> {{ inscricao_rede.tem_assinatura ? 'SIM' : 'NÃO' }}
                                </v-flex>
                                <v-flex xs5>
                                    <b>Cliente Plus:</b> {{ inscricao_rede.cliente_plus ? 'SIM' : 'NÃO' }}
                                </v-flex>
                                <v-flex xs5>
                                    <b>Pontuação:</b> {{ inscricao_rede.pontuacao }} {{ inscricao_rede.pontuacao === 1 ? 'pt' : 'pts' }}
                                </v-flex>
                                <v-flex xs12 class="mt-3">
                                    <v-btn round small block color="primary" @click="() => tooglePlusCustomer(true)">
                                        <v-icon class="mr-1">{{ inscricao_rede.cliente_plus ? 'star' : 'star_outline' }}</v-icon> {{ inscricao_rede.cliente_plus ? 'Retira Plus' : 'Tornar Plus' }}
                                    </v-btn>
                                </v-flex>
                                <template v-if="inscricao_rede.assinatura">
                                    <v-flex xs12 class="mt-3">
                                        <h3
                                            class="text-xs-center"
                                            style="font-weight:400;"
                                        >
                                            Dados da Assinatura
                                        </h3>
                                    </v-flex>
                                    <v-flex xs5 class="mt-3">
                                        <b>Plano:</b> {{ inscricao_rede.assinatura.plano ? inscricao_rede.assinatura.plano.descricao : 'Não informado' }}
                                    </v-flex>
                                    <v-flex xs5 class="mt-3">
                                        <b>Valor:</b> {{ inscricao_rede.assinatura.plano.valor | currency({fractionCount: 2}) }}
                                    </v-flex>
                                    <v-flex xs5 class="mt-3">
                                        <b>Data de assinatura:</b> {{ inscricao_rede.assinatura.data | formatDate('DD/MM/YYYY') }}
                                    </v-flex>
                                    <v-flex xs5 class="mt-3">
                                        <b>Data de cobrança:</b> {{ inscricao_rede.assinatura.data_cobranca | formatDate('DD/MM/YYYY') }}
                                    </v-flex>
                                    <v-flex xs5 class="mt-3">
                                        <b>Data de encerramento:</b> {{ inscricao_rede.assinatura.data_encerramento | formatDate('DD/MM/YYYY') }}
                                    </v-flex>
                                </template>
                            </v-layout>
                        </v-card-text>
                        </v-card>
                        <v-flex xs12 class="mt-4">
                            <h4 class="text-xs-center">Combustíveis Comprados</h4>
                            <v-list v-if="inscricao_rede">
                                <template v-for="(combustivel, index) in inscricao_rede.combustiveis">
                                    <v-divider :key="`${index}d`"></v-divider>
                                    <v-list-tile :key="`${index}l`">
                                        <v-list-tile-avatar>
                                            <svg-filler
                                            :path="combustivel.icone ? require(`@/assets/combs/${combustivel.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                                            width="50px"
                                            height="50px"
                                            :fill="combustivel.color"
                                            />
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ combustivel.nome }}</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-flex>
                    </v-tab-item>
                </v-tabs>
                </v-flex>
                <template v-if="cliente.assinatura">
                    <v-flex xs12 class="mt-4">
                        <h4 class="text-xs-center">Dados da Assinatura</h4>
                    </v-flex>
                    <v-flex xs5 class="mt-3">
                        <b>Plano:</b> {{ cliente.assinatura.plano ? cliente.assinatura.plano.descricao : 'Não informado' }}
                    </v-flex>
                    <v-flex xs5 class="mt-3">
                        <b>Valor:</b> {{ cliente.assinatura.plano.valor | currency({fractionCount: 2}) }}
                    </v-flex>
                    <v-flex xs5 class="mt-3">
                        <b>Data de assinatura:</b> {{ cliente.assinatura.data | formatDate('DD/MM/YYYY') }}
                    </v-flex>
                    <v-flex xs5 class="mt-3">
                        <b>Data de cobrança:</b> {{ cliente.assinatura.data_cobranca | formatDate('DD/MM/YYYY') }}
                    </v-flex>
                    <v-flex xs5 class="mt-3">
                        <b>Data de encerramento:</b> {{ cliente.assinatura.data_encerramento | formatDate('DD/MM/YYYY') }}
                    </v-flex>
                </template>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
  props: ['cliente'],
  beforeMount () {
    if (this.cliente.inscricao_posto && this.cliente.inscricao_posto.length > 0) {
      this.inscricao_posto = this.cliente.inscricao_posto.find((ip) => !!ip.posto)
      this.inscricao_rede = this.cliente.inscricao_posto.find((ip) => !!ip.rede)
    }
  },
  data: () => ({
    active: null,
    inscricao_posto: undefined,
    inscricao_rede: undefined
  }),
  computed: {
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    isSubscriber (listaInscricoes) {
      if (!listaInscricoes || listaInscricoes.length === 0) return false
      const lista = listaInscricoes.filter((obj) => {
        return obj.cliente_plus
      })
      return lista.length > 0
    },
    isPlus (listaInscricoes) {
      if (!listaInscricoes || listaInscricoes.length === 0) return false
      const lista = listaInscricoes.filter((obj) => {
        return !!obj.assinatura
      })
      return lista.length > 0
    },
    tooglePlusCustomer (isRede) {
      const data = {
        id_cliente: this.cliente.id_cliente,
        is_rede: isRede,
        posto: this.posto.cnpj
      }
      this.$store.dispatch('tooglePlus', data).then(() => {
        if (isRede) {
          this.inscricao_rede.cliente_plus = !this.inscricao_rede.cliente_plus
        } else {
          this.inscricao_posto.cliente_plus = !this.inscricao_posto.cliente_plus
        }
        this.$emit('carregar')
      }).catch((e) => {
        alert(e.message)
      })
    }
  }
}
</script>
